import { render, staticRenderFns } from "./Burden.vue?vue&type=template&id=774b0e80&"
import script from "./Burden.vue?vue&type=script&lang=ts&"
export * from "./Burden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VRow})
